import React, { useEffect, useState } from 'react'

let quotePopupRequest

export const preloadQuotePopup = () => {
  if (!quotePopupRequest) quotePopupRequest = import('./QuotePopup')
  return quotePopupRequest
}

const DeferredQuotePopup = props => {
  const [Popup, setPopup] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let active = true
    preloadQuotePopup()
      .then(module => {
        if (active) setPopup(() => module.default)
      })
      .catch(() => {
        quotePopupRequest = null
        if (active) setFailed(true)
      })
    return () => { active = false }
  }, [])

  if (failed) return <div role='alert'>The quote form could not load. Please close this window and try again.</div>
  if (!Popup) return <div role='status' aria-live='polite'>Loading quote form…</div>
  return <Popup {...props} />
}

export default DeferredQuotePopup
